// ─────────────────────────────────────────────────────────────
//  Réglages d'affichage – Salon RENT 2026
//  Les lots et leurs probabilités se règlent dans le CRM : crm-optimmo/backend/app/jeux.py (GAMES)
// ─────────────────────────────────────────────────────────────

export const EVENT_NAME = "Salon RENT 2026";
export const EVENT_CITY = "Paris";
export const STAND = "SD04";
export const GRAND_PRIZE = "un week-end Spa & Dîner pour 2";

export const GAME_URL =
  "https://jeu.optimmo-energies.com/?utm_source=salon_rent_paris_2026&utm_medium=qr&utm_campaign=jeu_roue_fortune";

export const SITE_URL =
  "https://www.optimmo-energies.com/?utm_source=salon_rent_paris_2026&utm_medium=jeu&utm_campaign=jeu_roue_fortune";

// API publique du CRM Optimmo (service crm-webhooks, module backend/app/jeux.py du dépôt crm-optimmo)
export const CRM_URL =
  (process.env.REACT_APP_CRM_URL && process.env.REACT_APP_CRM_URL.trim().replace(/\/$/, "")) ||
  (process.env.NODE_ENV === "development" ? "http://localhost:8000" : "");
export const GAME_SLUG = process.env.REACT_APP_GAME_SLUG || "salon-rent-2026";
export const GAME_API = `${CRM_URL}/jeux/${GAME_SLUG}`;

// Liste de secours si le CRM ne répond pas (doit rester alignée avec GAMES dans crm-optimmo/backend/app/jeux.py)
export const FALLBACK_PRIZES = [
  { id: "simulation", label: "Simulation offerte", short: "Simulation\nofferte" },
  { id: "stylo", label: "Stylo Optimmo", short: "Stylo" },
  { id: "remise20", label: "-20 % sur Optimmo", short: "-20 %" },
  { id: "carnet", label: "Carnet Optimmo", short: "Carnet" },
  { id: "remise50", label: "-50 % sur Optimmo", short: "-50 %" },
  { id: "totebag", label: "Tote bag Optimmo", short: "Tote bag" },
  { id: "grandlot", label: "Week-end Spa & Dîner pour 2", short: "Week-end\nSpa", grand: true },
];

export const standLabel = () => (STAND ? `le stand ${STAND}` : "le stand Optimmo");
